// Main API host location
export const apiDomain = "https://eg3.egms.pro";
// export const apiDomain = 'https://eg3v2.egms.pro'

// Detail for user info
export const getClientDetailUrl = apiDomain + "/api/getdetails/";

export const getClientGemlUrl = apiDomain + "/api/getgems/";

// Detail for analytics
export const getmissedcallcount = apiDomain + "/api/getmissedcallcount/";

// detail for groups
export const getusergroups = apiDomain + "/api/getusergroups/";
export const createusergroup = apiDomain + "/api/createusergroup/";
export const getusersingroup = apiDomain + "/api/getusersingroup/";
export const editusergroup = apiDomain + "/api/editusergroup/";
export const deletegenericgroup = apiDomain + "/api/deletegenericgroup/";
export const updatenotificationreceivers =
  apiDomain + "/api/updatenotificationreceivers/";
export const getnotificationsetting =
  apiDomain + "/api/getnotificationsetting/";
export const setnotificationsetting =
  apiDomain + "/api/setnotificationsetting/";

//datepicker
export const getconvolistbydate = apiDomain + "/api/getconvolistbydate/";

// detail for blocklist
export const getblocklistnumbers = apiDomain + "/api/getblocklistnumbers/";
export const deleteblocklistnumber = apiDomain + "/api/deleteblocklistnumber/";

// detail for notification receiver
export const getnotificationreceivers =
  apiDomain + "/api/getnotificationreceivers/";
export const setnotificationreceivers =
  apiDomain + "/api/setnotificationreceivers/";
export const setblocklistnumber = apiDomain + "/api/setblocklistnumber/";

// detail for other tasks

export const loginUrl = apiDomain + "/api/login/";

export const setsmsUrl = apiDomain + "/api/setmissedcallreply/";

export const getsmsUrl = apiDomain + "/api/getactivesmsreply/";

export const getSmsHistoryUrl = apiDomain + "/api/getmissedcalls/";

export const sendcampaignUrl = apiDomain + "/api/savecampaign/";
export const savecampaign = apiDomain + "/api/savecampaign/";
export const getcampaigns = apiDomain + "/api/getcampaigns/";

export const sendBulkUrl = apiDomain + "/api/sendbulk/";

// detail for chat

export const convolistUrl = apiDomain + "/api/getconvolist/";

export const getmessagesUrl = apiDomain + "/api/getmessages/";

export const sendreplyUrl = apiDomain + "/api/sendreply/";

export const addNewContact = apiDomain + "/api/savegenericuser/";
export const getAllContacts = apiDomain + "/api/getallcontacts/";
export const searchAllContacts = apiDomain + "/api/searchgenericuser/";
export const editgenericuser = apiDomain + "/api/editgenericuser/";
export const getgenericuser = apiDomain + "/api/getgenericuser/";

//get CSV
export const exportCSVURL = apiDomain + "/api/getmissedcallcsv/0";

export const getHeader = function() {
  const tokenData = JSON.parse(window.sessionStorage.getItem("authUser"));

  const headers = {
    Authorization: "Token " + tokenData.access_token
  };
  return headers;
};



// WEBPACK FOOTER //
// ./src/config.js